/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment } from 'react'

import { EuiFlexGroup, EuiPageHeader, EuiSpacer } from '@elastic/eui'

import { PAGE_BREADCRUMBS } from '@modules/ccm-components/breadcrumbs'
import Breadcrumbs from '@modules/cui/Breadcrumbs'
import { FormattedMessage } from '@modules/i18n'

import ExportTableButton from './ExportTableButton'
import FilterableConnectedClusterTable from './FilterableConnectedClusterTable'

import type { FC } from 'react'

const ClusterListPage: FC = () => (
  <Fragment>
    <Breadcrumbs breadcrumbs={[...PAGE_BREADCRUMBS]} />

    <EuiPageHeader
      paddingSize='none'
      bottomBorder={true}
      pageTitle={
        <FormattedMessage id='ccm.cluster-list-page.title' defaultMessage='Connected clusters' />
      }
      rightSideItems={[<ExportTableButton />]}
    />
    <EuiFlexGroup direction='column' justifyContent='center' alignItems='center'>
      <EuiSpacer size='m' />
      <FilterableConnectedClusterTable />
    </EuiFlexGroup>
  </Fragment>
)

export default ClusterListPage
